import { Injectable } from "@angular/core";
import {FilterParams} from "app/models/filter_form.model";
import {FilterFormService} from "app/views/filter_form/filter_form.service";

import merge from 'lodash-es/merge';
import * as qs from 'qs';
import * as moment from 'moment-timezone';
import {getServerName} from "app/lib/lib";
import { SupportQuery } from "app/models/support";
import { TranslateService } from '../translate';
import { Site } from "../models/support.model";

import * as dictionary from "../../dict/static.json";

// Добавить typed.d и в него - dictionary. И убрать эту порнуху
const config: any = dictionary['config'];
const locations: any = dictionary['locations'];
const socialFilter: any = dictionary['socialFilter'];
const serverAliasList: any = dictionary['serverAliasList'];
const serverZoneList: any = dictionary['serverZoneList'];
const subjectList: any = dictionary['subjectList'];
const templateList: any = dictionary['templateList'];
const processorList: any = dictionary['processorList'];
const currencyList: any = dictionary['currencyList'];
const tariffVariantList: any = dictionary['tariffVariantList'];
const tariffIdList: any = dictionary['tariffIdList'];
const localesMap: any = dictionary['localesMap'];

const
	convertAmountToDollarHash: { [key:string]: string} = {
		'all': '$',
		'rub': 'R',
		'usd': '$',
		'brl': 'R$',
		'ngn': '₦',
		'pln': 'zł',
	},
	utmList: string[] = [
		'utm_source', 'utm_medium', 'utm_campaign',
		'utm_term', 'utm_content', 'utm_landing',
		'gclid'
	];


class SiteHelper {
	static getDomainUrl(site: Site): string {
		return `https://${site._source === 1 ? '' : 'c2.'}ukit.com/sites/url/${site.url}/dashBoard`;
	}
}

@Injectable()
export class HelperService {
	site = SiteHelper;
	
	get locations() { return locations }
	get socialFilter() { return socialFilter }
	get serverAliasList() { return serverAliasList }
	get serverZoneList() { return serverZoneList }
	get subjectList() { return subjectList }
	get templateList() { return templateList }
	get processorList() { return processorList }
	get currencyList() { return currencyList }
	get tariffVariantList() { return tariffVariantList }
	get tariffIdList() { return tariffIdList }
	get localesMap() {
		return Object.keys(localesMap).reduce(function(obj, key) {
			obj[key] = localesMap[key];
			return obj;
		}, {
			'all'    : this._translate.instant('adminstat.common.any'),
			'not_ru' : 'not_ru'
		});
	}
	constructor(
		private filterService: FilterFormService,
		private _translate: TranslateService,
	) { }

	getUrlParams(queryParams: FilterParams, addParams?: FilterParams) {
		let params: FilterParams;

		if (addParams) {
			Object.keys(addParams).forEach(function (p) {
				if (addParams[p]) {
					let data = {};
					data[p] = addParams[p];
					queryParams = merge({}, queryParams, data);
				}
			});
		}

		params = merge({}, this.filterService.getDiffParams(queryParams), {t: Date.now()});
		params.chartFormat = 'c3angular';
		
		return qs.stringify(params, { encode: false });
	}


	percentageFormat(number) {
		return (isNaN(number) ? '0' : Math.floor(number * 1000) / 10) + '%';
	}
	
	
	convertAmountToDollar(amount, postfix): string {
		if ( ! amount) {
			return '0';
		}
		
		const newAmount = parseInt(amount, 10) / 100;
		
		
		if ( ! postfix) {
			return newAmount.toString();
		}
		
		return `${newAmount} ${convertAmountToDollarHash[postfix] || postfix}`;
	}


	getTimeAsIntervals(opts) {
		let start  = opts.timestamp,
			period = opts.period,
			dates  = [];

		if (period == 'day') {
			dates = [
				moment.utc(start).add(3, 'hour').startOf('day').format('DD.MM.YYYY'),
			]
		} else {
			if (period == 'week') {
				dates = [
					moment.utc(start).add(3, 'hour').startOf('isoWeek').format('DD.MM.YYYY'),
					moment.utc(start).add(3, 'hour').endOf('isoWeek').format('DD.MM.YYYY')
				];
			} else if (period == 'month') {
				dates = [
					moment.utc(start).add(3, 'hour').startOf('month').format('DD.MM.YYYY'),
					moment.utc(start).add(3, 'hour').endOf('month').format('DD.MM.YYYY')
				];
			} else if (period == 'year') {
				dates = [
					moment.utc(start).add(3, 'hour').startOf('year').format('DD.MM.YYYY'),
					moment.utc(start).add(3, 'hour').endOf('year').format('DD.MM.YYYY')
				];
			} else if (period == 'summary') {
				dates = [
					''
				];
			}
		}

		return dates;
	}
	
	
	public currencyLabels = {
		all : 'All',
		usd : '$',
		rub : '₽',
		brl : 'R$',
		pln : 'zł',
		ngn : '₦',
		ukt : 'UKT'
	};


	/**
	 * Ограничить вызов fn в интервале limit миллисекунд
	 * @param {Function} fn
	 * @param {number} limit
	 * 
	 * @return {Function} Функция, которая будет вызвана не чаще чем раз в limit миллисекунд
	 */
	delimit(fn: Function, limit: number = 1000): Function {
		let timer = null;
		
		return function (...args) {
			if (timer) {
				clearTimeout(timer);
			}
			
			timer = setTimeout(
				() => fn.apply(this, args),
				limit
			);
		}
	}
	
	
	getUtmList() {
		return utmList;
	}
	
	
	getServerHost() {
		return `http://${getServerName()}`
	}
	
	
	getSupportUrl(opts: SupportQuery): string {
		if ( ! opts) {
			throw new Error('helper.service.openSupportPage error: opts is not define!');
		}
		
		const key = [
			'site', 'siteId',
			'email', 'userId',
			'invoiceNumber',
			'username',
		].find(key => opts[key]);
		
		const params = {
			typeFilter : key,
			value      : opts[key]
		};
		
		if (key === 'site') {
			params['accurateSiteSearch'] = true;
		}
		
		return `${config.baseUrl}/support?${qs.stringify(params, { encode: false })}`;
	}
	
	getDashboarUrl(site: Site) {
		return `https://${site._source === 1 ? '' : 'c2.'}${getServerName()}/sites/url/${site.url}/dashBoard`;
	}
}
